import { useMutation, useQuery } from 'react-query';
import { useStoreMap } from 'effector-react';
import { API_DOMAIN } from '@constants';
import type {
  SeatData,
  SeatDepartmentData,
  SeatItem,
} from '@modules/header/ShareConfigModal/types';
import axios from '@utils/axios';
import { $tourData } from '@stores/dataStores';

export function useSeatMembers() {
  return useQuery(
    ['seat-members'],
    () => {
      return axios.get<SeatData>(`${API_DOMAIN}/team/member/seat-members`);
    },
    {
      staleTime: 180000,
    }
  );
}

export function useDepartmentMembers(departmentId: number) {
  return useQuery(
    ['dept-members', departmentId],
    () => {
      return axios.get<SeatDepartmentData>(
        `${API_DOMAIN}/team/member/seat-members`,
        {
          params: { departmentId },
        }
      );
    },
    {
      staleTime: 180000,
    }
  );
}

type SeatConfigResponse = {
  operatorId: number;
  ownerId: number;
  list: SeatItem[];
};

export function useSeatConfig({
  onSuccess,
}: {
  onSuccess?: (data: SeatConfigResponse) => void;
} = {}) {
  const id = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (tourData) => tourData.id,
  });
  return useQuery(
    ['seat-config', id],
    () => {
      return axios.get<SeatConfigResponse>(
        `${API_DOMAIN}/team/app/tours/${id}/internal-view`
      );
    },
    {
      onSuccess,
    }
  );
}

export function useModifySeatSetting() {
  const id = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (tourData) => tourData.id,
  });
  return useMutation(
    ['modify-seat-setting', id],
    async (payload: {
      addData: { accessScope: SeatItem['accessScope']; relationId: number }[];
      removeData: (number | string)[];
    }) => {
      return axios.post(`${API_DOMAIN}/team/app/tours/${id}/internal-view`, {
        addData: JSON.stringify(payload.addData),
        removeData: payload.removeData.join(','),
      });
    }
  );
}
